<script>
import Spinner from '@/components/ui/loader/Spinner.vue'

export default {
  components: {
    'mia-spinner': Spinner
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default: 'Lädt...'
    }
  }
}
</script>

<template>
  <transition
    enter-class="opacity-0 transform translate-y-10"
    enter-active-class="transition-all duration-150 ease-out"
    enter-to-class="opacity-100 transform translate-y-0"
    leave-class="opacity-100 transform translate-y-0"
    leave-active-class="transition-all duration-150 ease-in"
    leave-to-class="opacity-0 transform translate-y-10"
  >
    <div
      v-if="show"
      class="fixed bottom-0 mb-2 left-0 z-50 w-full pointer-events-none"
      style="padding-left: 250px"
    >
      <div class="w-full p-4 pr-8">
        <div class="w-full bg-gray-mia rounded-md shadow-xl p-4 pointer-events-auto relative overflow-hidden">
          <div class="flex items-center space-x-12">
            <div
              v-if="label"
              class="text-white text-sm"
            >
              {{ label }}
            </div>
            <div class="flex-1 flex items-center space-x-6">
              <slot />
            </div>
            <div>
              <button
                type="button"
                class="w-10 h-10 inline-flex items-center justify-center rounded text-gray-300 hover:bg-orange-mia hover:text-white focus:outline-none focus:shadow-outline-mia"
                title="Abbrechen"
                @click="$emit('cancel')"
              >
                <mia-streamline-icon
                  class="w-5 h-5 fill-current"
                  src="close"
                />
              </button>
            </div>
          </div>

          <transition
            enter-class="opacity-0"
            enter-active-class="transition-opacity duration-150 ease-out"
            enter-to-class="opacity-100"
            leave-class="opacity-100"
            leave-active-class="transition-opacity duration-150 ease-in"
            leave-to-class="opacity-0"
          >
            <div
              v-if="loading"
              class="absolute left-0 top-0 w-full h-full bg-black bg-opacity-75 p-4 flex items-center text-white"
            >
              <mia-spinner class="w-8 h-8" />
              <span class="ml-5">{{ loadingText }}</span>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </transition>
</template>
